// The pack/case text every surface shows (the product card's `Case` wherever it is mounted, the
// product page's `Pack/Case` cell, the upsell toast, the scan panel, the search dropdown and the
// Order Review's PACK/CASE column): the catalogue's retail units and its case size
// (`pack_description`), joined `{retailUnits} / {packSize}`. SL1.0 renders `RetailUnits /
// CaseSize` (`get_orders_cost.php:313`), the Figma frames draw the same, and the RBP module's
// `packSizeOf` follows the same rule. The values keep their case; each part loses only the spaces
// round it, a blank part is dropped, and one part alone shows with no slash (ADO-2249, BWG
// feedback).

/** The pack/case text, or `null` when the catalogue holds neither fact for the product. */
export function packCaseLabel(
  retailUnits: string | null | undefined,
  packSize: string | null | undefined,
): string | null {
  const parts = [retailUnits, packSize]
    .map((part) => part?.trim() ?? '')
    .filter((part) => part !== '');
  return parts.length === 0 ? null : parts.join(' / ');
}
